<app-menu></app-menu>

<div class="cadastros-page">
  <header class="page-header">
    <p>ControlPS / Cadastros</p>
    <h1>{{ 'CADASTROS.TITLE' | translate }}</h1>
    <small>{{ 'CADASTROS.SUBTITLE' | translate }}</small>
  </header>

  <div class="feedback" *ngIf="feedbackMessage" [class.success]="feedbackType === 'success'" [class.error]="feedbackType === 'error'">
    {{ feedbackMessage }}
  </div>

  <section class="cards-grid">
    <article
      class="card-action"
      *ngIf="canCadastrosView('environments')"
      [class.disabled]="!canCadastrosCreate('environments')"
      (click)="canCadastrosCreate('environments') && openModal('environment')"
    >
      <div class="icon">
        <mat-icon>domain</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.ENV.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.ENV.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosView('environments')" (click)="openEnvironmentList($event)">
          {{ 'CADASTROS.CARDS.ENV.LIST' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('users')"
      [class.disabled]="!canCadastrosCreate('users')"
      (click)="canCadastrosCreate('users') && openUserModal()"
    >
      <div class="icon">
        <mat-icon>person_add</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.USER.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.USER.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosView('users')" (click)="openUsersList($event)">
          {{ 'CADASTROS.CARDS.USER.LIST' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('documents')"
      [class.disabled]="!canCadastrosCreate('documents')"
      (click)="canCadastrosCreate('documents') && openDocumentModal()"
    >
      <div class="icon">
        <mat-icon>picture_as_pdf</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.DOCS.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.DOCS.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosCreate('documents')" (click)="openDocumentModal($event)">
          {{ 'CADASTROS.CARDS.DOCS.CTA' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('sectors')"
      [class.disabled]="!canCadastrosCreate('sectors')"
      (click)="canCadastrosCreate('sectors') && openModal('sector')"
    >
      <div class="icon">
        <mat-icon>business</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.SECTOR.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.SECTOR.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosView('sectors')" (click)="openSectorList($event)">
          {{ 'CADASTROS.CARDS.SECTOR.LIST' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('departments')"
      [class.disabled]="!canCadastrosCreate('departments')"
      (click)="canCadastrosCreate('departments') && openModal('department')"
    >
      <div class="icon">
        <mat-icon>account_tree</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.DEPARTMENT.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.DEPARTMENT.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosView('departments')" (click)="openDepartmentList($event)">
          {{ 'CADASTROS.CARDS.DEPARTMENT.LIST' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('locations')"
      [class.disabled]="!canCadastrosCreate('locations')"
      (click)="canCadastrosCreate('locations') && openModal('location')"
    >
      <div class="icon">
        <mat-icon>place</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.LOCATION.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.LOCATION.DESC' | translate }}</p>
        <button type="button" class="ghost" *ngIf="canCadastrosView('locations')" (click)="openLocationList($event)">
          {{ 'CADASTROS.CARDS.LOCATION.LIST' | translate }}
        </button>
      </div>
    </article>

    <article
      class="card-action"
      *ngIf="canCadastrosView('positions')"
      [class.disabled]="!canCadastrosCreate('positions')"
      (click)="canCadastrosCreate('positions') && openModal('position')"
    >
      <div class="icon">
        <mat-icon>badge</mat-icon>
      </div>
      <div>
        <h3>{{ 'CADASTROS.CARDS.POSITION.TITLE' | translate }}</h3>
        <p>{{ 'CADASTROS.CARDS.POSITION.DESC' | translate }}</p>
      </div>
    </article>
  </section>

    <!-- MODAL ANTIGA -->

  <!--<ng-container *ngIf="activeModal === 'environment'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide cad-environment-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Ambientes</span>
          <h2>{{ editingEnvironment ? ('CADASTROS.ENV.EDIT_TITLE' | translate) : ('CADASTROS.ENV.NEW_TITLE' | translate) }}</h2>
          <p>{{ 'CADASTROS.ENV.LIST_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <form (ngSubmit)="submitEnvironment()">
        <div class="modal-body">
          <div class="digital-admission-form-surface">
            <div class="env-tabs">
              <button
                type="button"
                [class.active]="environmentTab === 'cadastro'"
                (click)="setEnvironmentTab('cadastro')">
                Cadastro
              </button>
              <button
                type="button"
                [class.active]="environmentTab === 'modulos'"
                (click)="setEnvironmentTab('modulos')">
                Módulos
              </button>
              <button
                type="button"
                [class.active]="environmentTab === 'logo-cor'"
                (click)="setEnvironmentTab('logo-cor')">
                Logo & Cor
              </button>
            </div>

            <div class="env-tab-pane" [class.tab-pane-hidden]="environmentTab !== 'cadastro'">
              <div class="form-grid cad-environment-grid">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>{{ 'CADASTROS.ENV.NAME' | translate }}</mat-label>
                  <input matInput type="text" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).tenant_name" [name]="editingEnvironment ? 'edit_tenant_name' : 'tenant_name'" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>{{ 'CADASTROS.ENV.DOCUMENT' | translate }}</mat-label>
                  <input matInput type="text" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).document_num" [name]="editingEnvironment ? 'edit_document_num' : 'document_num'" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>{{ 'CADASTROS.ENV.RESPONSIBLE' | translate }}</mat-label>
                  <input matInput type="text" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).responsible_name" [name]="editingEnvironment ? 'edit_responsible_name' : 'responsible_name'" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>{{ 'CADASTROS.ENV.EMAIL' | translate }}</mat-label>
                  <input matInput type="email" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).responsible_email" [name]="editingEnvironment ? 'edit_responsible_email' : 'responsible_email'" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="digital-field modal-standard-field cad-full cad-textarea-field">
                  <mat-label>{{ 'CADASTROS.ENV.NOTES' | translate }}</mat-label>
                  <textarea matInput rows="3" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).notes" [name]="editingEnvironment ? 'edit_notes' : 'notes'"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline" class="digital-field modal-standard-field cad-full cad-textarea-field">
                  <mat-label>{{ 'CADASTROS.ENV.IP_LABEL' | translate }}</mat-label>
                  <textarea
                    matInput
                    rows="3"
                    [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).allowed_ips"
                    [name]="editingEnvironment ? 'edit_allowed_ips' : 'allowed_ips'"></textarea>
                  <mat-hint>{{ 'CADASTROS.ENV.IP_HELP' | translate }}</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="env-tab-pane" [class.tab-pane-hidden]="environmentTab !== 'modulos'">
              <div class="module-picker">
                <div class="module-picker-header">
                  <p class="label">{{ 'CADASTROS.ENV.MODULES' | translate }}</p>
                  <mat-slide-toggle
                    [checked]="isAllEnvironmentModulesSelected"
                    (change)="toggleAllEnvironmentModules($event.checked)">
                    Marcar todos
                  </mat-slide-toggle>
                </div>
                <div class="module-grid">
                  <div class="module-item" *ngFor="let module of moduleCatalog">
                    <span class="module-item-label">{{ module.labelKey ? (module.labelKey | translate) : (module.name || module.key) }}</span>
                    <mat-slide-toggle
                      [checked]="environmentModules.includes(module.key)"
                      (change)="toggleEnvironmentModule(module.key, $event.checked)">
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>

            <div class="env-tab-pane env-brand-pane" [class.tab-pane-hidden]="environmentTab !== 'logo-cor'">
              <div class="color-inputs">
                <label class="color-item">
                  <span>{{ 'CADASTROS.ENV.PRIMARY_COLOR' | translate }}</span>
                  <input type="color" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).primary_color" [name]="editingEnvironment ? 'edit_primary_color' : 'primary_color'">
                </label>

                <label class="color-item">
                  <span>{{ 'CADASTROS.ENV.SECONDARY_COLOR' | translate }}</span>
                  <input type="color" [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).secondary_color" [name]="editingEnvironment ? 'edit_secondary_color' : 'secondary_color'">
                </label>
              </div>

              <div class="dropzones">
                <div
                  class="drop-area"
                  [class.dragging]="dragging.logo"
                  (dragover)="onDragOver($event)"
                  (dragenter)="onDragEnter('logo')"
                  (dragleave)="onDragLeave('logo')"
                  (drop)="onFileDrop($event, 'logo')"
                  (click)="logoInput.click()"
                >
                  <input type="file" accept="image/*" #logoInput (change)="onFileSelect($event, 'logo')">
                  <ng-container *ngIf="logoPreview; else logoPlaceholder">
                    <img [src]="logoPreview" alt="Logo selecionada">
                  </ng-container>
                  <ng-template #logoPlaceholder>
                    <mat-icon>image</mat-icon>
                    <p>{{ 'CADASTROS.ENV.LOGO_HINT' | translate }}</p>
                  </ng-template>
                </div>

                <div
                  class="drop-area"
                  [class.dragging]="dragging.cover"
                  (dragover)="onDragOver($event)"
                  (dragenter)="onDragEnter('cover')"
                  (dragleave)="onDragLeave('cover')"
                  (drop)="onFileDrop($event, 'cover')"
                  (click)="coverInput.click()"
                >
                  <input type="file" accept="image/*" #coverInput (change)="onFileSelect($event, 'cover')">
                  <ng-container *ngIf="coverPreview; else coverPlaceholder">
                    <img [src]="coverPreview" alt="Capa selecionada">
                  </ng-container>
                  <ng-template #coverPlaceholder>
                    <mat-icon>collections</mat-icon>
                    <p>{{ 'CADASTROS.ENV.COVER_HINT' | translate }}</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actions digital-admission-actions">
          <button type="button" class="secondary digital-btn digital-btn--ghost" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button type="submit" class="digital-btn digital-btn--primary" [disabled]="savingEnvironment">
            {{
              savingEnvironment
                ? ('CADASTROS.SAVING' | translate)
                : (editingEnvironment ? ('CADASTROS.ENV.SAVE_CHANGES' | translate) : ('CADASTROS.ENV.SAVE' | translate))
            }}
          </button>
        </div>
      </form>
    </section>
  </ng-container> -->

  <!-- MODAL PADRAO GLOBAL-->

<ng-container *ngIf="activeModal === 'environment'">
  <div class="modal-backdrop" (click)="closeModal()"></div>

  <section class="modal-card cp-modal-fixed-height" (click)="$event.stopPropagation()">

    <!-- HEADER -->
    <header class="modal-header">
      <div>
        <h2>
          {{ editingEnvironment ? ('CADASTROS.ENV.EDIT_TITLE' | translate) : ('CADASTROS.ENV.NEW_TITLE' | translate) }}
        </h2>
        <small>{{ 'CADASTROS.ENV.LIST_TITLE' | translate }}</small>
      </div>

      <button class="icon" type="button" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <!-- BODY -->
    <form (ngSubmit)="submitEnvironment()" class="cp-modal-body">

      <div class="cp-tabs">
        <button
          mat-stroked-button
          type="button"
          [class.active]="environmentTab === 'cadastro'"
          (click)="setEnvironmentTab('cadastro')">
          <mat-icon>business</mat-icon>
          Cadastro
        </button>

        <button
          mat-stroked-button
          type="button"
          [class.active]="environmentTab === 'modulos'"
          (click)="setEnvironmentTab('modulos')">
          <mat-icon>grid_view</mat-icon>
          Módulos
        </button>

        <button
          mat-stroked-button
          type="button"
          [class.active]="environmentTab === 'logo-cor'"
          (click)="setEnvironmentTab('logo-cor')">
          <mat-icon>palette</mat-icon>
          Logo &amp; Cor
        </button>
      </div>

      <!-- CONTEUDO SCROLL -->
      <div class="cp-modal-scroll">

        <!-- CADASTRO -->
        <section class="panel" [class.tab-pane-hidden]="environmentTab !== 'cadastro'">
          <header>
            <h3>Dados do ambiente</h3>
          </header>

          <div class="form-row">

            <mat-form-field appearance="outline">
              <mat-label>{{ 'CADASTROS.ENV.NAME' | translate }}</mat-label>
              <input matInput type="text"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).tenant_name"
                [name]="editingEnvironment ? 'edit_tenant_name' : 'tenant_name'" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'CADASTROS.ENV.DOCUMENT' | translate }}</mat-label>
              <input matInput type="text"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).document_num"
                [name]="editingEnvironment ? 'edit_document_num' : 'document_num'" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'CADASTROS.ENV.RESPONSIBLE' | translate }}</mat-label>
              <input matInput type="text"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).responsible_name"
                [name]="editingEnvironment ? 'edit_responsible_name' : 'responsible_name'" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'CADASTROS.ENV.EMAIL' | translate }}</mat-label>
              <input matInput type="email"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).responsible_email"
                [name]="editingEnvironment ? 'edit_responsible_email' : 'responsible_email'" required>
            </mat-form-field>

            <mat-form-field appearance="outline" class="cp-textarea">
              <mat-label>{{ 'CADASTROS.ENV.NOTES' | translate }}</mat-label>
              <textarea matInput rows="3"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).notes"
                [name]="editingEnvironment ? 'edit_notes' : 'notes'">
              </textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="cp-textarea">
              <mat-label>{{ 'CADASTROS.ENV.IP_LABEL' | translate }}</mat-label>
              <textarea matInput rows="3"
                [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).allowed_ips"
                [name]="editingEnvironment ? 'edit_allowed_ips' : 'allowed_ips'">
              </textarea>
              <mat-hint>{{ 'CADASTROS.ENV.IP_HELP' | translate }}</mat-hint>
            </mat-form-field>

          </div>
        </section>

        <!-- MODULOS -->
        <section class="panel" [class.tab-pane-hidden]="environmentTab !== 'modulos'">
          <header>
            <h3>{{ 'CADASTROS.ENV.MODULES' | translate }}</h3>
          </header>

          <div class="module-picker-header">
            <span class="visibility-label">Seleção</span>
            <mat-slide-toggle
              [checked]="isAllEnvironmentModulesSelected"
              (change)="toggleAllEnvironmentModules($event.checked)">
              Marcar todos
            </mat-slide-toggle>
          </div>

          <div class="module-grid">
            <div class="module-item" *ngFor="let module of moduleCatalog">
              <span class="module-item-label">
                {{ module.labelKey ? (module.labelKey | translate) : (module.name || module.key) }}
              </span>

              <mat-slide-toggle
                [checked]="environmentModules.includes(module.key)"
                (change)="toggleEnvironmentModule(module.key, $event.checked)">
              </mat-slide-toggle>
            </div>
          </div>
        </section>

        <!-- LOGO & COR -->
        <section class="panel" [class.tab-pane-hidden]="environmentTab !== 'logo-cor'">
          <header>
            <h3>Identidade visual</h3>
          </header>

          <div class="env-brand-grid">

            <div class="color-inputs">

              <label class="color-item">
                <span>{{ 'CADASTROS.ENV.PRIMARY_COLOR' | translate }}</span>
                <input type="color"
                  [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).primary_color"
                  [name]="editingEnvironment ? 'edit_primary_color' : 'primary_color'">
              </label>

              <label class="color-item">
                <span>{{ 'CADASTROS.ENV.SECONDARY_COLOR' | translate }}</span>
                <input type="color"
                  [(ngModel)]="(editingEnvironment ? editingForm : environmentForm).secondary_color"
                  [name]="editingEnvironment ? 'edit_secondary_color' : 'secondary_color'">
              </label>

            </div>

            <div class="dropzone-grid">
              <div
                class="dropzone full"
                [class.dragging]="dragging.logo"
                (dragover)="onDragOver($event)"
                (dragenter)="onDragEnter('logo')"
                (dragleave)="onDragLeave('logo')"
                (drop)="onFileDrop($event, 'logo')"
                (click)="logoInput.click()">
                <input type="file" accept="image/*" #logoInput (change)="onFileSelect($event, 'logo')">
                <ng-container *ngIf="logoPreview; else logoPlaceholder">
                  <div class="dropzone-preview">
                    <img [src]="logoPreview" alt="Logo selecionada">
                    <p>{{ 'CADASTROS.ENV.LOGO_HINT' | translate }}</p>
                  </div>
                </ng-container>
                <ng-template #logoPlaceholder>
                  <div class="dropzone-content">
                    <mat-icon>image</mat-icon>
                    <p>{{ 'CADASTROS.ENV.LOGO_HINT' | translate }}</p>
                  </div>
                </ng-template>
              </div>

              <div
                class="dropzone full"
                [class.dragging]="dragging.cover"
                (dragover)="onDragOver($event)"
                (dragenter)="onDragEnter('cover')"
                (dragleave)="onDragLeave('cover')"
                (drop)="onFileDrop($event, 'cover')"
                (click)="coverInput.click()">
                <input type="file" accept="image/*" #coverInput (change)="onFileSelect($event, 'cover')">
                <ng-container *ngIf="coverPreview; else coverPlaceholder">
                  <div class="dropzone-preview">
                    <img [src]="coverPreview" alt="Capa selecionada">
                    <p>{{ 'CADASTROS.ENV.COVER_HINT' | translate }}</p>
                  </div>
                </ng-container>
                <ng-template #coverPlaceholder>
                  <div class="dropzone-content">
                    <mat-icon>collections</mat-icon>
                    <p>{{ 'CADASTROS.ENV.COVER_HINT' | translate }}</p>
                  </div>
                </ng-template>
              </div>
            </div>

          </div>
        </section>

      </div>

      <!-- FOOTER -->
      <footer class="entry-footer">

        <button mat-stroked-button type="button" (click)="closeModal()">
          {{ 'COMMON.CANCEL' | translate }}
        </button>

        <button mat-raised-button color="primary" type="submit" [disabled]="savingEnvironment">
          {{
            savingEnvironment
              ? ('CADASTROS.SAVING' | translate)
              : (editingEnvironment ? ('CADASTROS.ENV.SAVE_CHANGES' | translate) : ('CADASTROS.ENV.SAVE' | translate))
          }}
        </button>

      </footer>

    </form>

  </section>
</ng-container>




  <ng-container *ngIf="activeModal === 'user'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-user-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ editingUser ? ('CADASTROS.USER.EDIT_TITLE' | translate) : ('CADASTROS.USER.NEW_TITLE' | translate) }}</h2>
          <small>{{ 'CADASTROS.USER.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitUserForm()" class="cp-modal-body">
        <div class="cp-tabs user-step-tabs" *ngIf="!editingUser">
          <button mat-stroked-button type="button" [class.active]="userStep === 1" (click)="goToUserStep(1)">1. {{ 'CADASTROS.USER.STEP_DATA' | translate }}</button>
          <button mat-stroked-button type="button" [class.active]="userStep === 2" (click)="goToUserStep(2)">2. {{ 'CADASTROS.USER.STEP_LINK' | translate }}</button>
          <button mat-stroked-button type="button" [class.active]="userStep === 3" (click)="goToUserStep(3)">3. {{ 'CADASTROS.USER.STEP_MODULES' | translate }}</button>
        </div>

        <div class="cp-tabs user-step-tabs" *ngIf="editingUser">
          <button mat-stroked-button type="button" [class.active]="userEditTab === 1" (click)="setUserEditTab(1)">{{ 'CADASTROS.USER.STEP_DATA' | translate }}</button>
          <button mat-stroked-button type="button" [class.active]="userEditTab === 2" (click)="setUserEditTab(2)">{{ 'CADASTROS.USER.STEP_LINK' | translate }}</button>
          <button mat-stroked-button type="button" [class.active]="userEditTab === 3" (click)="setUserEditTab(3)">{{ 'CADASTROS.USER.STEP_MODULES' | translate }}</button>
        </div>

        <div class="cp-modal-scroll cad-user-scroll">
          <ng-container *ngIf="(!editingUser && userStep === 1) || (editingUser && userEditTab === 1)">
            <section class="panel">
            <div class="form-grid cad-user-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.FULL_NAME' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="userForm.name" name="user_name" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.EMAIL' | translate }}</mat-label>
                <input matInput type="email" [(ngModel)]="userForm.email" name="user_email" required (blur)="validateUserEmailAvailability()">
                <mat-hint *ngIf="checkingUserEmail">{{ 'Verificando e-mail...' }}</mat-hint>
                <mat-hint *ngIf="userEmailFeedback && !checkingUserEmail" class="form-hint error">{{ userEmailFeedback }}</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.EMPLOYEE' | translate }}</mat-label>
                <mat-icon matPrefix>auto_awesome</mat-icon>
                <input matInput type="text" [(ngModel)]="userForm.employee_id" name="user_employee">
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="employee-lookup-action"
                  (click)="lookupEmployeeByCode()"
                  [disabled]="employeeLookupLoading || !(userForm.employee_id || '').trim()"
                  aria-label="Buscar colaborador por matrícula">
                  <mat-icon>search</mat-icon>
                </button>
                <mat-hint *ngIf="employeeLookupLoading">{{ 'CADASTROS.USER.LOOKUP_LOADING' | translate }}</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.BIRTH' | translate }}</mat-label>
                <input matInput type="date" [(ngModel)]="userForm.birth_date" name="user_birth_date">
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cad-full">
                <mat-label>{{ 'CADASTROS.USER.ROLE' | translate }}</mat-label>
                <mat-select [(ngModel)]="userForm.role_id" name="user_role" required [disabled]="loadingRoles">
                  <mat-option [value]="''" disabled>{{ 'CADASTROS.USER.SELECT_ROLE' | translate }}</mat-option>
                  <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="loadingRoles">{{ 'CADASTROS.USER.ROLES_LOADING' | translate }}</mat-hint>
              </mat-form-field>
            </div>

            <div class="toggle-wrapper" *ngIf="editingUser && !isPendingUser(editingUser)">
              <mat-slide-toggle [(ngModel)]="userActiveToggle" name="user_active">
                {{ 'CADASTROS.USER.ACTIVE' | translate }}
              </mat-slide-toggle>
            </div>

            <p class="form-hint">{{ 'CADASTROS.USER.HINT_ACTIVATION' | translate }}</p>
            </section>
          </ng-container>

          <ng-container *ngIf="(!editingUser && userStep === 2) || (editingUser && userEditTab === 2)">
            <section class="panel">
            <div class="form-grid cad-user-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.SECTOR' | translate }}</mat-label>
                <mat-select [(ngModel)]="userForm.sector_id" name="user_sector" (ngModelChange)="onUserSectorChange($event)">
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.USER.DEPARTMENT' | translate }}</mat-label>
                <mat-select [(ngModel)]="userForm.department_id" name="user_department" (ngModelChange)="onUserDepartmentChange($event)">
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let dept of getDepartmentsBySector(userForm.sector_id)" [value]="dept.id">{{ dept.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="userForm.sector_id && !getDepartmentsBySector(userForm.sector_id).length">
                  {{ 'CADASTROS.USER.DEPARTMENT_HINT' | translate }}
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cad-full">
                <mat-label>{{ 'CADASTROS.USER.LOCATION' | translate }}</mat-label>
                <mat-select [(ngModel)]="userForm.location_id" name="user_location" (ngModelChange)="onUserLocationChange($event)">
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let loc of getLocationsByDepartment(userForm.department_id)" [value]="loc.id">{{ loc.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="userForm.department_id && !getLocationsByDepartment(userForm.department_id).length">
                  {{ 'CADASTROS.USER.LOCATION_HINT' | translate }}
                </mat-hint>
              </mat-form-field>
            </div>

            <p class="form-hint">{{ 'CADASTROS.USER.HINT_LINK' | translate }}</p>
            </section>
          </ng-container>

          <ng-container *ngIf="(!editingUser && userStep === 3) || (editingUser && userEditTab === 3)">
            <section class="panel">
            <div class="cp-tabs permissions-subtabs">
              <button mat-stroked-button
                type="button"
                [class.active]="userPermissionsSubTab === 'modules'"
                (click)="setUserPermissionsSubTab('modules')">
                Módulos
              </button>
              <button mat-stroked-button
                type="button"
                *ngIf="showCadastrosPermissions()"
                [class.active]="userPermissionsSubTab === 'cadastros'"
                (click)="setUserPermissionsSubTab('cadastros')">
                Itens de Cadastros
              </button>
              <button mat-stroked-button
                type="button"
                *ngIf="showControlopSelection()"
                [class.active]="userPermissionsSubTab === 'controlop'"
                (click)="setUserPermissionsSubTab('controlop')">
                Escopo ControlOP
              </button>
              <button mat-stroked-button
                type="button"
                *ngIf="showControlhelpSelection()"
                [class.active]="userPermissionsSubTab === 'controlhelp'"
                (click)="setUserPermissionsSubTab('controlhelp')">
                Escopo ControlHelp
              </button>
            </div>

            <button
              type="button"
              class="permissions-subtab-back"
              *ngIf="userPermissionsSubTab !== 'modules'"
              (click)="setUserPermissionsSubTab('modules')">
              <mat-icon>arrow_back</mat-icon>
              Voltar para módulos
            </button>

            <ng-container *ngIf="userPermissionsSubTab === 'modules'">
              <p class="form-hint">{{ 'CADASTROS.USER.HINT_MODULES' | translate }}</p>
              <div class="module-permissions module-permissions--scroll">
                <div class="module-row header">
                  <span>{{ 'CADASTROS.USER.MODULE' | translate }}</span>
                  <span>{{ 'CADASTROS.USER.VIEW' | translate }}</span>
                  <span>{{ 'CADASTROS.USER.CREATE' | translate }}</span>
                  <span>{{ 'CADASTROS.USER.MANAGE' | translate }}</span>
                </div>
                <div class="module-row" *ngFor="let module of availableModules">
                  <span>{{ module.labelKey ? (module.labelKey | translate) : (module.name || module.key) }}</span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userModulePermissions[module.key].can_view"
                      [disabled]="module.can_view === 0"
                      (change)="toggleUserModulePermission(module.key, 'can_view', $event.checked)"
                      [attr.aria-label]="'Permitir visualizar módulo ' + (module.name || module.key)">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userModulePermissions[module.key].can_create"
                      [disabled]="!userModulePermissions[module.key].can_view || module.can_create === 0"
                      (change)="toggleUserModulePermission(module.key, 'can_create', $event.checked)"
                      [attr.aria-label]="'Permitir criar no módulo ' + (module.name || module.key)">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userModulePermissions[module.key].can_manage"
                      [disabled]="!userModulePermissions[module.key].can_view || module.can_manage === 0"
                      (change)="toggleUserModulePermission(module.key, 'can_manage', $event.checked)"
                      [attr.aria-label]="'Permitir gerenciar no módulo ' + (module.name || module.key)">
                    </mat-slide-toggle>
                  </span>
                </div>
              </div>
            </ng-container>

            <div class="cadastros-permissions" *ngIf="userPermissionsSubTab === 'cadastros' && showCadastrosPermissions()">
              <p class="form-hint">{{ 'CADASTROS.USER.HINT_CADASTROS' | translate }}</p>
              <div class="module-permissions">
                <div class="module-row header">
                  <span>{{ 'CADASTROS.USER.ITEM' | translate }}</span>
                  <span class="permission-column-header">
                    <span>{{ 'CADASTROS.USER.VIEW' | translate }}</span>
                    <mat-slide-toggle
                      [checked]="isCadastrosColumnAllSelected('can_view')"
                      (change)="toggleCadastrosColumn('can_view', $event.checked)"
                      aria-label="Selecionar todos para visualizar">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-column-header">
                    <span>{{ 'CADASTROS.USER.CREATE' | translate }}</span>
                    <mat-slide-toggle
                      [checked]="isCadastrosColumnAllSelected('can_create')"
                      (change)="toggleCadastrosColumn('can_create', $event.checked)"
                      aria-label="Selecionar todos para criar">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-column-header">
                    <span>{{ 'CADASTROS.USER.MANAGE' | translate }}</span>
                    <mat-slide-toggle
                      [checked]="isCadastrosColumnAllSelected('can_manage')"
                      (change)="toggleCadastrosColumn('can_manage', $event.checked)"
                      aria-label="Selecionar todos para gerenciar">
                    </mat-slide-toggle>
                  </span>
                </div>
                <div class="module-row" *ngFor="let item of cadastrosItems">
                  <span>{{ item.labelKey | translate }}</span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userCadastrosPermissions[item.key].can_view"
                      (change)="toggleCadastrosPermission(item.key, 'can_view', $event.checked)"
                      [attr.aria-label]="'Permitir visualizar item ' + item.key">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userCadastrosPermissions[item.key].can_create"
                      [disabled]="!userCadastrosPermissions[item.key].can_view"
                      (change)="toggleCadastrosPermission(item.key, 'can_create', $event.checked)"
                      [attr.aria-label]="'Permitir criar item ' + item.key">
                    </mat-slide-toggle>
                  </span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="userCadastrosPermissions[item.key].can_manage"
                      [disabled]="!userCadastrosPermissions[item.key].can_view"
                      (change)="toggleCadastrosPermission(item.key, 'can_manage', $event.checked)"
                      [attr.aria-label]="'Permitir gerenciar item ' + item.key">
                    </mat-slide-toggle>
                  </span>
                </div>
              </div>
            </div>

            <div class="controlop-permissions" *ngIf="userPermissionsSubTab === 'controlop' && showControlopSelection()">
              <p class="form-hint">{{ 'CADASTROS.CONTROLOP.HINT' | translate }}</p>
              <div class="controlop-tabs">
                <p class="label">{{ 'CADASTROS.CONTROLOP.TABS' | translate }}</p>
                <div class="controlop-tab-grid">
                  <label class="controlop-tab-item" *ngFor="let tab of controlopTabOptions">
                    <span class="controlop-tab-item-label">{{ tab.labelKey | translate }}</span>
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="controlopTabs.includes(tab.key)"
                      (change)="toggleControlopTab(tab.key, $event.checked)"
                      [attr.aria-label]="'Ativar aba ' + (tab.labelKey | translate)">
                    </mat-slide-toggle>
                  </label>
                </div>
              </div>
              <div class="controlop-dept-actions" *ngIf="departments.length">
                <button mat-stroked-button type="button" class="controlop-select-all" (click)="toggleControlopDepartmentsAll()">
                  {{ controlopSelectAllLabel }}
                </button>
              </div>
              <div class="module-permissions controlop-scope-table">
                <div class="module-row header">
                  <span>{{ 'CADASTROS.CONTROLOP.DEPARTMENT' | translate }}</span>
                  <span>{{ 'CADASTROS.CONTROLOP.ACTIVE' | translate }}</span>
                </div>
                <div class="module-row" *ngFor="let dept of departments">
                  <span>{{ dept.sector_name ? (dept.sector_name + ' - ' + dept.name) : dept.name }}</span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="controlopDepartments.includes(dept.id)"
                      (change)="toggleControlopDepartment(dept.id, $event.checked)"
                      [attr.aria-label]="'Ativar departamento ' + dept.name">
                    </mat-slide-toggle>
                  </span>
                </div>
              </div>

              <div class="module-permissions controlop-scope-table controlop-location-table" *ngIf="controlopDepartments.length">
                <div class="module-row header">
                  <span>{{ 'CADASTROS.CONTROLOP.LOCATION' | translate }}</span>
                  <span>{{ 'CADASTROS.CONTROLOP.ACTIVE' | translate }}</span>
                </div>
                <div class="module-row" *ngFor="let loc of controlopAvailableLocations">
                  <span>{{ loc.name }}</span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="controlopLocations.includes(loc.id)"
                      (change)="toggleControlopLocation(loc.id, $event.checked)"
                      [attr.aria-label]="'Ativar local ' + loc.name">
                    </mat-slide-toggle>
                  </span>
                </div>
              </div>
            </div>

            <div class="controlop-permissions" *ngIf="userPermissionsSubTab === 'controlhelp' && showControlhelpSelection()">
              <p class="form-hint">Selecione os departamentos que este usuário poderá acompanhar no ControlHelp.</p>
              <div class="controlop-dept-actions" *ngIf="controlhelpDepartmentOptions.length">
                <button mat-stroked-button type="button" class="controlop-select-all" (click)="toggleControlhelpDepartmentsAll()">
                  {{ controlhelpSelectAllLabel }}
                </button>
              </div>
              <div class="module-permissions controlop-scope-table">
                <div class="module-row header">
                  <span>Departamento</span>
                  <span>Ativo</span>
                </div>
                <div class="module-row" *ngFor="let dept of controlhelpDepartmentOptions">
                  <span>{{ dept.sector_name ? (dept.sector_name + ' - ' + dept.name) : dept.name }}</span>
                  <span class="permission-cell">
                    <mat-slide-toggle
                      class="permission-toggle"
                      [checked]="controlhelpDepartments.includes(dept.id)"
                      (change)="toggleControlhelpDepartment(dept.id, $event.checked)"
                      [attr.aria-label]="'Ativar departamento ' + dept.name">
                    </mat-slide-toggle>
                  </span>
                </div>
              </div>
            </div>
            </section>
          </ng-container>
          <div class="form-feedback" *ngIf="userFeedback">{{ userFeedback }}</div>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-stroked-button type="button" *ngIf="userStep > 1 && !editingUser" (click)="goToUserStep(userStep - 1)">{{ 'CADASTROS.USER.BACK' | translate }}</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="savingUser || loadingRoles">
            {{
              userStep === 1 && !editingUser
                ? ('CADASTROS.USER.CONTINUE' | translate)
                : (savingUser
                    ? (editingUser ? ('CADASTROS.SAVING' | translate) : ('COMMON.SENDING' | translate))
                    : (editingUser ? ('CADASTROS.USER.SAVE_CHANGES' | translate) : ('CADASTROS.USER.SUBMIT' | translate)))
            }}
          </button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'document'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-document-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ 'CADASTROS.DOC.NEW_TITLE' | translate }}</h2>
          <small>{{ 'CADASTROS.DOC.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitDocument()" class="cp-modal-body">
        <div class="cp-modal-scroll">
          <section class="panel cad-document-form-panel">
            <div class="cp-form-row cad-document-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.DOC.TITLE' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="documentForm.title" name="doc_title" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.DOC.TYPE' | translate }}</mat-label>
                <mat-select [(ngModel)]="documentForm.document_type" name="doc_type">
                  <mat-option *ngFor="let option of documentTypeOptions" [value]="option.value">{{ option.labelKey | translate }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-textarea">
                <mat-label>{{ 'CADASTROS.DOC.DESC' | translate }}</mat-label>
                <textarea matInput rows="3" [(ngModel)]="documentForm.description" name="doc_description" [placeholder]="'CADASTROS.DOC.DESC_PLACEHOLDER' | translate"></textarea>
              </mat-form-field>
            </div>

            <div class="dropzone full cad-document-dropzone" (click)="documentFileInput.click()">
              <input type="file" accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt" #documentFileInput (change)="onDocumentFileChange($event)">
              <ng-container *ngIf="documentFileName; else cadDocPlaceholder">
                <div class="dropzone-content">
                  <mat-icon>description</mat-icon>
                  <div>
                    <p>{{ documentFileName }}</p>
                    <small>{{ 'CADASTROS.DOC.FILE_REPLACE' | translate }}</small>
                  </div>
                </div>
              </ng-container>
              <ng-template #cadDocPlaceholder>
                <div class="dropzone-content">
                  <mat-icon>cloud_upload</mat-icon>
                  <p>{{ 'CADASTROS.DOC.FILE_HINT' | translate }}</p>
                </div>
              </ng-template>
            </div>

            <div class="doc-toggles cad-document-toggles">
              <mat-slide-toggle [(ngModel)]="documentForm.require_read" name="doc_require_read">{{ 'CADASTROS.DOC.REQUIRE_READ' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="documentForm.require_accept" name="doc_require_accept">{{ 'CADASTROS.DOC.REQUIRE_ACCEPT' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="documentForm.require_agreement" name="doc_require_agreement">{{ 'CADASTROS.DOC.REQUIRE_AGREEMENT' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="documentForm.require_signature" name="doc_require_signature">{{ 'CADASTROS.DOC.REQUIRE_SIGNATURE' | translate }}</mat-slide-toggle>
            </div>
          </section>

          <section class="panel cad-document-list-panel">
            <h3>{{ 'CADASTROS.DOC.LIST_TITLE' | translate }}</h3>
            <div class="list-status" *ngIf="loadingDocuments">{{ 'CADASTROS.DOC.LOADING' | translate }}</div>
            <div class="list-status error" *ngIf="documentsError && !loadingDocuments">{{ documentsError }}</div>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field" *ngIf="!loadingDocuments && !documentsError">
              <mat-label>{{ 'CADASTROS.DOC.FILTER' | translate }}</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="text" [(ngModel)]="documentFilter" name="doc_filter">
            </mat-form-field>

            <div class="table-wrapper" *ngIf="!loadingDocuments && !documentsError">
              <table>
                <thead>
                  <tr>
                    <th>{{ 'CADASTROS.DOC.TABLE.TITLE' | translate }}</th>
                    <th>{{ 'CADASTROS.DOC.TABLE.TYPE' | translate }}</th>
                    <th>{{ 'CADASTROS.DOC.TABLE.REQUIREMENTS' | translate }}</th>
                    <th>{{ 'CADASTROS.DOC.TABLE.CREATED_AT' | translate }}</th>
                    <th>{{ 'CADASTROS.DOC.TABLE.FILE' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let doc of filteredDocuments">
                    <td>{{ doc.title }}</td>
                    <td>{{ doc.document_type | titlecase }}</td>
                    <td>
                      <span class="doc-req" *ngIf="doc.require_read">{{ 'CADASTROS.DOC.REQ_READ' | translate }}</span>
                      <span class="doc-req" *ngIf="doc.require_accept">{{ 'CADASTROS.DOC.REQ_ACCEPT' | translate }}</span>
                      <span class="doc-req" *ngIf="doc.require_agreement">{{ 'CADASTROS.DOC.REQ_AGREEMENT' | translate }}</span>
                      <span class="doc-req" *ngIf="doc.require_signature">{{ 'CADASTROS.DOC.REQ_SIGNATURE' | translate }}</span>
                    </td>
                    <td>{{ doc.created_at | date:'short' }}</td>
                    <td>
                      <a [href]="formatDocumentUrl(doc.file_path)" target="_blank" rel="noopener">{{ 'CADASTROS.DOC.DOWNLOAD' | translate }}</a>
                    </td>
                  </tr>
                  <tr *ngIf="!filteredDocuments.length">
                    <td colspan="5" class="empty">{{ 'CADASTROS.DOC.EMPTY' | translate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="savingDocument">
            {{ savingDocument ? ('CADASTROS.SAVING' | translate) : ('CADASTROS.DOC.SAVE' | translate) }}
          </button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'sector'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-sector-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ 'CADASTROS.SECTOR.NEW_TITLE' | translate }}</h2>
          <small>{{ 'CADASTROS.SECTOR.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitSector()" class="cp-modal-body">
        <div class="cp-modal-scroll">
          <section class="panel">
            <div class="cp-form-row cad-sector-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.SECTOR.NAME' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="sectorForm.name" name="sector_name" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-textarea">
                <mat-label>{{ 'CADASTROS.SECTOR.DESC' | translate }}</mat-label>
                <textarea matInput rows="3" [(ngModel)]="sectorForm.description" name="sector_description"></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>ControlHelp</mat-label>
                <mat-select [(ngModel)]="sectorForm.controlhelp_scope" name="sector_controlhelp_scope">
                  <mat-option *ngFor="let option of controlhelpScopeOptions" [value]="option.value">
                    <span class="cad-scope-option">
                      <mat-icon>{{ option.icon }}</mat-icon>
                      <span>
                        <strong>{{ option.label }}</strong>
                        <small>{{ option.description }}</small>
                      </span>
                    </span>
                  </mat-option>
                </mat-select>
                <mat-hint>Define se o setor aparece como origem, destino, ambos ou nenhum no ControlHelp.</mat-hint>
              </mat-form-field>
            </div>
          </section>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-raised-button color="primary" type="submit">{{ 'CADASTROS.SECTOR.SAVE' | translate }}</button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'department'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-department-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ 'CADASTROS.DEPARTMENT.NEW_TITLE' | translate }}</h2>
          <small>{{ 'CADASTROS.DEPARTMENT.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitDepartment()" class="cp-modal-body">
        <div class="cp-modal-scroll">
          <section class="panel">
            <div class="cp-form-row cad-department-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.DEPARTMENT.SECTOR' | translate }}</mat-label>
                <mat-select [(ngModel)]="departmentForm.sector_id" name="department_sector" required>
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="!sectors.length">{{ 'CADASTROS.DEPARTMENT.SECTOR_HINT' | translate }}</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.DEPARTMENT.NAME' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="departmentForm.name" name="department_name" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-textarea">
                <mat-label>{{ 'CADASTROS.DEPARTMENT.DESC' | translate }}</mat-label>
                <textarea matInput rows="3" [(ngModel)]="departmentForm.description" name="department_description"></textarea>
              </mat-form-field>
            </div>
          </section>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-raised-button color="primary" type="submit">{{ 'CADASTROS.DEPARTMENT.SAVE' | translate }}</button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'location'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-location-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ 'CADASTROS.LOCATION.NEW_TITLE' | translate }}</h2>
          <small>{{ 'CADASTROS.LOCATION.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitLocation()" class="cp-modal-body">
        <div class="cp-modal-scroll">
          <section class="panel">
            <div class="cp-form-row cad-location-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.LOCATION.SECTOR' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="locationForm.sector_id"
                  name="location_sector"
                  required
                  (ngModelChange)="onLocationSectorChange()">
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="!sectors.length">{{ 'CADASTROS.LOCATION.SECTOR_HINT' | translate }}</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.LOCATION.DEPARTMENT' | translate }}</mat-label>
                <mat-select [(ngModel)]="locationForm.department_id" name="location_department" required>
                  <mat-option [value]="''">{{ 'COMMON.SELECT' | translate }}</mat-option>
                  <mat-option *ngFor="let dept of getDepartmentsBySector(locationForm.sector_id)" [value]="dept.id">{{ dept.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="locationForm.sector_id && !getDepartmentsBySector(locationForm.sector_id).length">
                  {{ 'CADASTROS.LOCATION.DEPARTMENT_HINT' | translate }}
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.LOCATION.NAME' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="locationForm.name" name="location_name" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-textarea">
                <mat-label>{{ 'CADASTROS.LOCATION.DESC' | translate }}</mat-label>
                <textarea matInput rows="3" [(ngModel)]="locationForm.description" name="location_description"></textarea>
              </mat-form-field>
            </div>
          </section>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-raised-button color="primary" type="submit">{{ 'CADASTROS.LOCATION.SAVE' | translate }}</button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'position'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal-card cp-modal-fixed-height cad-position-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>{{ 'CADASTROS.POSITION.NEW_TITLE' | translate }}</h2>
          <small>{{ 'CADASTROS.POSITION.LIST_TITLE' | translate }}</small>
        </div>
        <button class="icon" type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form (ngSubmit)="submitPosition()" class="cp-modal-body">
        <div class="cp-modal-scroll">
          <section class="panel cad-position-form-panel">
            <div class="cp-form-row cad-position-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.POSITION.NAME' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="positionForm.name" name="position_name" required>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'CADASTROS.POSITION.SALARY' | translate }}</mat-label>
                <input matInput type="number" step="0.01" [(ngModel)]="positionForm.base_salary" name="position_salary">
              </mat-form-field>
            </div>
          </section>

          <section class="panel cad-position-list-panel">
            <h3>{{ 'CADASTROS.POSITION.LIST_TITLE' | translate }}</h3>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field">
              <mat-label>{{ 'CADASTROS.POSITION.FILTER' | translate }}</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="text" [(ngModel)]="positionFilter" name="position_filter">
            </mat-form-field>

            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>{{ 'CADASTROS.POSITION.TABLE.NAME' | translate }}</th>
                    <th>{{ 'CADASTROS.POSITION.TABLE.SALARY' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pos of filteredPositions">
                    <td>{{ pos.name }}</td>
                    <td>{{ pos.base_salary || ('CADASTROS.EMPTY' | translate) }}</td>
                  </tr>
                  <tr *ngIf="!filteredPositions.length">
                    <td colspan="2" class="empty">{{ 'CADASTROS.POSITION.EMPTY' | translate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        <footer class="entry-footer">
          <button mat-stroked-button type="button" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button mat-raised-button color="primary" type="submit">{{ 'CADASTROS.POSITION.SAVE' | translate }}</button>
        </footer>
      </form>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'environment-list'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide modal-list cad-environment-list-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Ambientes</span>
          <h2>{{ 'CADASTROS.ENV.LIST_TITLE' | translate }}</h2>
          <p>{{ 'CADASTROS.ENV.NEW_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <div class="modal-body">
        <div *ngIf="loadingEnvironments" class="list-status">{{ 'COMMON.LOADING_LIST' | translate }}</div>
        <div *ngIf="listError" class="list-status error">{{ listError }}</div>

        <div class="list-status success" *ngIf="listMessage">{{ listMessage }}</div>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field" *ngIf="!loadingEnvironments && !listError">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            [placeholder]="'CADASTROS.ENV.FILTER' | translate"
            [ngModel]="envFilter"
            (ngModelChange)="onEnvironmentFilterChange($event)">
        </mat-form-field>

        <div class="table-wrapper" *ngIf="!loadingEnvironments && !listError">
          <table>
            <thead>
              <tr>
                <th>{{ 'CADASTROS.TABLE.ID' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.NAME' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.DOCUMENT' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.RESPONSIBLE' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.CREATED_BY' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.DATE' | translate }}</th>
                <th>{{ 'CADASTROS.ENV.TABLE.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let env of paginatedEnvironments"
                [class.row-clickable]="canCadastrosManage('environments')"
                (click)="canCadastrosManage('environments') && editEnvironment(env)"
              >
                <td>{{ env.id }}</td>
                <td>{{ env.tenant_name }}</td>
                <td>{{ env.document_num }}</td>
                <td>{{ env.responsible_name }}</td>
                <td>{{ env.created_by_name || env.created_by || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ env.created_at | date:'short' }}</td>
                <td class="actions" (click)="$event.stopPropagation()">
                  <ng-container *ngIf="canCadastrosManage('environments')">
                    <button
                      type="button"
                      class="row-actions-trigger"
                      [matMenuTriggerFor]="environmentRowMenu"
                      (click)="$event.stopPropagation()"
                      aria-label="Ações"
                    >
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #environmentRowMenu="matMenu" xPosition="before" class="cad-row-actions-menu">
                      <button mat-menu-item (click)="editEnvironment(env)">
                        <mat-icon>edit</mat-icon>
                        <span>Editar</span>
                      </button>
                      <button mat-menu-item (click)="resendMasterEmail(env)" [disabled]="!env.responsible_email">
                        <mat-icon>mail</mat-icon>
                        <span>Reenviar e-mail</span>
                      </button>
                      <button mat-menu-item class="menu-item-danger" (click)="openDeleteConfirm(env)">
                        <mat-icon>delete</mat-icon>
                        <span>Excluir</span>
                      </button>
                    </mat-menu>
                  </ng-container>
                </td>
              </tr>
              <tr *ngIf="!paginatedEnvironments.length">
                <td colspan="7" class="empty">{{ 'CADASTROS.ENV.EMPTY' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-pagination" *ngIf="!loadingEnvironments && !listError">
          <div class="pagination-summary">
            Mostrando {{ environmentStartItem }}-{{ environmentEndItem }} de {{ environmentTotalItems }}
          </div>

          <div class="pagination-controls">
            <label class="page-size-control">
              <span>Por página</span>
              <select [ngModel]="envPageSize" (ngModelChange)="onEnvironmentPageSizeChange($event)">
                <option *ngFor="let size of envPageSizeOptions" [ngValue]="size">{{ size }}</option>
              </select>
            </label>

            <button type="button" class="ghost pagination-btn" (click)="goToEnvironmentPrevPage()" [disabled]="environmentCurrentPage <= 1">
              Anterior
            </button>
            <span class="pagination-page-indicator">{{ environmentCurrentPage }} / {{ environmentTotalPages }}</span>
            <button type="button" class="ghost pagination-btn" (click)="goToEnvironmentNextPage()" [disabled]="environmentCurrentPage >= environmentTotalPages">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'sector-list'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide modal-list cad-environment-list-modal cad-sector-list-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Setores</span>
          <h2>{{ 'CADASTROS.SECTOR.LIST_TITLE' | translate }}</h2>
          <p>{{ 'CADASTROS.SECTOR.NEW_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <div class="modal-body">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" [placeholder]="'CADASTROS.SECTOR.FILTER' | translate" [(ngModel)]="sectorFilter">
        </mat-form-field>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>{{ 'CADASTROS.TABLE.ID' | translate }}</th>
                <th>{{ 'CADASTROS.TABLE.TENANT' | translate }}</th>
                <th>{{ 'CADASTROS.SECTOR.TABLE.SECTOR' | translate }}</th>
                <th>{{ 'CADASTROS.SECTOR.TABLE.DESC' | translate }}</th>
                <th>{{ 'CADASTROS.SECTOR.TABLE.CONTROLHELP' | translate }}</th>
                <th>{{ 'CADASTROS.SECTOR.TABLE.CREATED_AT' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sector of filteredSectors">
                <td>{{ sector.id }}</td>
                <td>{{ sector.tenant_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ sector.name }}</td>
                <td>{{ sector.description || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>
                  <button
                    type="button"
                    class="cad-scope-chip"
                    [ngClass]="'scope-' + sectorControlhelpScope(sector).toLowerCase()"
                    [matMenuTriggerFor]="sectorScopeMenu">
                    <mat-icon>{{ controlhelpScopeIcon(sectorControlhelpScope(sector)) }}</mat-icon>
                    <span>{{ controlhelpScopeLabel(sectorControlhelpScope(sector)) }}</span>
                    <mat-icon class="chevron">expand_more</mat-icon>
                  </button>
                  <mat-menu #sectorScopeMenu="matMenu" class="cad-scope-menu">
                    <button
                      type="button"
                      mat-menu-item
                      *ngFor="let option of controlhelpScopeOptions"
                      [class.active]="sectorControlhelpScope(sector) === option.value"
                      (click)="updateSectorControlhelpScope(sector, option.value)">
                      <mat-icon>{{ option.icon }}</mat-icon>
                      <span class="cad-scope-menu-text">
                        <strong>{{ option.label }}</strong>
                        <small>{{ option.description }}</small>
                      </span>
                    </button>
                  </mat-menu>
                </td>
                <td>{{ sector.created_at | date:'short' }}</td>
              </tr>
              <tr *ngIf="!filteredSectors.length">
                <td colspan="6" class="empty">{{ 'CADASTROS.SECTOR.EMPTY' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'department-list'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide modal-list cad-environment-list-modal cad-department-list-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Departamentos</span>
          <h2>{{ 'CADASTROS.DEPARTMENT.LIST_TITLE' | translate }}</h2>
          <p>{{ 'CADASTROS.DEPARTMENT.NEW_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <div class="modal-body">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" [placeholder]="'CADASTROS.DEPARTMENT.FILTER' | translate" [(ngModel)]="departmentFilter">
        </mat-form-field>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>{{ 'CADASTROS.TABLE.ID' | translate }}</th>
                <th>{{ 'CADASTROS.DEPARTMENT.TABLE.DEPARTMENT' | translate }}</th>
                <th>{{ 'CADASTROS.DEPARTMENT.TABLE.SECTOR' | translate }}</th>
                <th>{{ 'CADASTROS.DEPARTMENT.TABLE.DESC' | translate }}</th>
                <th>{{ 'CADASTROS.DEPARTMENT.TABLE.CREATED_AT' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dept of filteredDepartments">
                <td>{{ dept.id }}</td>
                <td>{{ dept.name }}</td>
                <td>{{ dept.sector_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ dept.description || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ dept.created_at | date:'short' }}</td>
              </tr>
              <tr *ngIf="!filteredDepartments.length">
                <td colspan="5" class="empty">{{ 'CADASTROS.DEPARTMENT.EMPTY' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeModal === 'location-list'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide modal-list cad-environment-list-modal cad-location-list-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Locais</span>
          <h2>{{ 'CADASTROS.LOCATION.LIST_TITLE' | translate }}</h2>
          <p>{{ 'CADASTROS.LOCATION.NEW_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <div class="modal-body">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" [placeholder]="'CADASTROS.LOCATION.FILTER' | translate" [(ngModel)]="locationFilter">
        </mat-form-field>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>{{ 'CADASTROS.TABLE.ID' | translate }}</th>
                <th>{{ 'CADASTROS.LOCATION.TABLE.LOCATION' | translate }}</th>
                <th>{{ 'CADASTROS.LOCATION.TABLE.DEPARTMENT' | translate }}</th>
                <th>{{ 'CADASTROS.LOCATION.TABLE.SECTOR' | translate }}</th>
                <th>{{ 'CADASTROS.LOCATION.TABLE.DESC' | translate }}</th>
                <th>{{ 'CADASTROS.LOCATION.TABLE.CREATED_AT' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of filteredLocations">
                <td>{{ loc.id }}</td>
                <td>{{ loc.name }}</td>
                <td>{{ loc.department_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ loc.sector_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ loc.description || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ loc.created_at | date:'short' }}</td>
              </tr>
              <tr *ngIf="!filteredLocations.length">
                <td colspan="6" class="empty">{{ 'CADASTROS.LOCATION.EMPTY' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeUsersModal === 'users-list'">
    <div class="modal-backdrop" (click)="closeModal()"></div>
    <section class="modal wide modal-list cad-user-list-modal">
      <header class="digital-admission-modal__header">
        <div class="digital-admission-modal__title-wrap">
          <span class="digital-admission-modal__eyebrow">ControlDP · Usuários</span>
          <h2>{{ 'CADASTROS.USER.LIST_TITLE' | translate }}</h2>
          <p>{{ 'CADASTROS.USER.NEW_TITLE' | translate }}</p>
        </div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </header>

      <div class="modal-body">
        <div class="list-status" *ngIf="loadingUsers">{{ 'COMMON.LOADING_LIST' | translate }}</div>
        <div class="list-status error" *ngIf="usersError && !loadingUsers">{{ usersError }}</div>
        <div class="list-status success" *ngIf="usersMessage && !loadingUsers">{{ usersMessage }}</div>

        <div class="user-list-filters" *ngIf="!loadingUsers && !usersError">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field filter-field search-filter-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              type="text"
              [placeholder]="'CADASTROS.USER.FILTER' | translate"
              [ngModel]="userFilter"
              (ngModelChange)="onUserFilterChange($event)">
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="digital-field modal-standard-field filter-field">
            <mat-label>Status</mat-label>
            <mat-select [ngModel]="userStatusFilter" (ngModelChange)="onUserStatusFilterChange($event)">
              <mat-option value="ALL">Todos os status</mat-option>
              <mat-option value="ACTIVE">Ativo</mat-option>
              <mat-option value="PENDING">Pendente</mat-option>
              <mat-option value="INACTIVE">Inativo</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="digital-field modal-standard-field filter-field">
            <mat-label>Departamento</mat-label>
            <mat-select [ngModel]="userDepartmentFilter" (ngModelChange)="onUserDepartmentFilterChange($event)">
              <mat-option value="ALL">Todos os departamentos</mat-option>
              <mat-option *ngFor="let department of userDepartmentOptions" [value]="department.id">
                {{ department.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            *ngIf="canViewUsersFromAllTenants"
            appearance="outline"
            class="digital-field modal-standard-field filter-field user-environment-filter">
            <mat-label>Ambiente</mat-label>
            <mat-select [ngModel]="userEnvironmentFilter" (ngModelChange)="onUserEnvironmentFilterChange($event)">
              <mat-option value="ALL">Todos os ambientes</mat-option>
              <mat-option *ngFor="let env of userEnvironmentOptions" [value]="env.id">
                {{ env.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="table-wrapper" *ngIf="!loadingUsers && !usersError">
          <table>
            <thead>
              <tr>
                <th>{{ 'CADASTROS.USER.TABLE.ID' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.NAME' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.EMAIL' | translate }}</th>
                <th>Departamento</th>
                <th>{{ 'CADASTROS.USER.TABLE.TENANT' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.ROLE' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.CREATED_AT' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.ACTIVE' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.IP_ACCESS' | translate }}</th>
                <th>{{ 'CADASTROS.USER.TABLE.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let user of paginatedUsers"
                [class.row-clickable]="canCadastrosManage('users')"
                (click)="canCadastrosManage('users') && editUser(user)"
              >
                <td>{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.department_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ user.tenant_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ user.role_name || ('CADASTROS.EMPTY' | translate) }}</td>
                <td>{{ user.created_at | date:'short' }}</td>
                <td>
                  <span class="status-pill" [ngClass]="getUserStatusClasses(user)">
                    {{ getUserStatus(user) }}
                  </span>
                </td>
                <td class="ip-access-cell">
                  {{ user.ip_access_exempt ? ('CADASTROS.USER.IP_FREE' | translate) : ('CADASTROS.USER.IP_RESTRICTED' | translate) }}
                </td>
                <td class="actions" (click)="$event.stopPropagation()">
                  <ng-container *ngIf="canCadastrosManage('users')">
                    <button
                      type="button"
                      class="row-actions-trigger"
                      [matMenuTriggerFor]="userRowMenu"
                      (click)="$event.stopPropagation()"
                      aria-label="Ações"
                    >
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #userRowMenu="matMenu" xPosition="before" class="cad-row-actions-menu">
                      <button mat-menu-item (click)="editUser(user)">
                        <mat-icon>edit</mat-icon>
                        <span>Editar</span>
                      </button>
                      <button mat-menu-item (click)="toggleUserIpAccess(user)">
                        <mat-icon>{{ user.ip_access_exempt ? 'lock' : 'lock_open' }}</mat-icon>
                        <span>{{ user.ip_access_exempt ? ('CADASTROS.USER.IP_RESTRICTED' | translate) : ('CADASTROS.USER.IP_FREE' | translate) }}</span>
                      </button>
                      <button mat-menu-item (click)="resendUserEmail(user)" [disabled]="!isPendingUser(user)">
                        <mat-icon>mail</mat-icon>
                        <span>Reenviar acesso</span>
                      </button>
                      <button mat-menu-item (click)="resetUserPassword(user)">
                        <mat-icon>lock_reset</mat-icon>
                        <span>Resetar senha</span>
                      </button>
                      <button
                        mat-menu-item
                        [class.menu-item-danger]="getUserStatus(user) !== 'Inativo'"
                        (click)="openUserDelete(user)">
                        <mat-icon>{{ getUserStatus(user) === 'Inativo' ? 'person_add' : 'delete' }}</mat-icon>
                        <span>{{ isPendingUser(user) ? 'Excluir' : (getUserStatus(user) === 'Inativo' ? 'Reativar' : 'Inativar') }}</span>
                      </button>
                    </mat-menu>
                  </ng-container>
                </td>
              </tr>
              <tr *ngIf="!filteredUsers.length">
                <td colspan="10" class="empty">{{ 'CADASTROS.USER.EMPTY' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-pagination" *ngIf="!loadingUsers && !usersError">
          <div class="pagination-summary">
            Mostrando {{ userStartItem }}-{{ userEndItem }} de {{ userTotalItems }}
          </div>

          <div class="pagination-controls">
            <label class="page-size-control">
              <span>Por página</span>
              <select [ngModel]="userPageSize" (ngModelChange)="onUserPageSizeChange($event)">
                <option *ngFor="let size of userPageSizeOptions" [ngValue]="size">{{ size }}</option>
              </select>
            </label>

            <button type="button" class="ghost pagination-btn" (click)="goToUserPrevPage()" [disabled]="userCurrentPage <= 1">
              Anterior
            </button>
            <span class="pagination-page-indicator">{{ userCurrentPage }} / {{ userTotalPages }}</span>
            <button type="button" class="ghost pagination-btn" (click)="goToUserNextPage()" [disabled]="userCurrentPage >= userTotalPages">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="deleteModal">
    <div class="modal-backdrop" (click)="cancelDelete()"></div>
    <section class="modal modal-confirm">
      <header>
        <h2>{{ 'CADASTROS.DELETE_ENV.TITLE' | translate }}</h2>
        <button type="button" class="close" (click)="cancelDelete()">&times;</button>
      </header>
      <p>{{ 'CADASTROS.DELETE_ENV.TEXT' | translate:{ name: deleteModal.name } }}</p>
      <div class="actions">
        <button type="button" class="secondary" (click)="cancelDelete()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="button" class="danger" [disabled]="deletingId === deleteModal.id" (click)="confirmDelete()">
          {{ deletingId === deleteModal.id ? ('CADASTROS.DELETING' | translate) : ('CADASTROS.CONFIRM_DELETE' | translate) }}
        </button>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="userDeleteModal">
    <div class="modal-backdrop" (click)="cancelUserDelete()"></div>
    <section class="modal-card cad-confirm-modal" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <h2>
            {{
              userDeleteModal.action === 'delete'
                ? ('CADASTROS.DELETE_USER.TITLE' | translate)
                : (userDeleteModal.action === 'reactivate' ? 'Reativar usuário' : 'Inativar usuário')
            }}
          </h2>
          <small>
            {{
              userDeleteModal.action === 'reactivate'
                ? 'Esta ação devolverá o acesso ao sistema.'
                : 'Esta ação remove o usuário da listagem ativa do sistema.'
            }}
          </small>
        </div>
        <button type="button" class="icon" (click)="cancelUserDelete()">
          <mat-icon>close</mat-icon>
        </button>
      </header>
      <div class="cp-modal-body cad-confirm-modal__body">
        <p>
          {{
            userDeleteModal.action === 'delete'
              ? ('CADASTROS.DELETE_USER.TEXT' | translate:{ name: userDeleteModal.name })
              : (
                  userDeleteModal.action === 'reactivate'
                    ? 'O usuário voltará a acessar o sistema com a senha atual.'
                    : 'Ao inativar, o usuário deixa de acessar o sistema, mas o histórico é preservado.'
                )
          }}
        </p>
      </div>
      <footer class="cp-modal__footer">
        <button mat-stroked-button type="button" (click)="cancelUserDelete()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button
          mat-raised-button
          [color]="userDeleteModal.action === 'reactivate' ? 'primary' : 'warn'"
          type="button"
          [disabled]="deletingUserId === userDeleteModal.id"
          (click)="confirmUserDelete()">
          {{
            deletingUserId === userDeleteModal.id
              ? ('CADASTROS.DELETING' | translate)
              : (
                  userDeleteModal.action === 'delete'
                    ? ('CADASTROS.CONFIRM_DELETE' | translate)
                    : (userDeleteModal.action === 'reactivate' ? 'Confirmar reativação' : 'Confirmar inativação')
                )
          }}
        </button>
      </footer>
    </section>
  </ng-container>
</div>
